'use es6';

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { useThreadPresence } from '../hooks/useThreadPresence';
import ThreadPresenceAvatars from './ThreadPresenceAvatars';
import { hasAgentPresenceAccess } from 'conversations-thread-data/auth/public/selectors';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadPresence = ({
  threadId
}) => {
  const hasAccess = useSelector(hasAgentPresenceAccess);
  const {
    asyncPresentSenders
  } = useThreadPresence({
    threadId
  });
  return asyncPresentSenders.size && hasAccess ? /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "thread-presence",
    children: [/*#__PURE__*/_jsx(ThreadPresenceAvatars, {
      asyncSenders: asyncPresentSenders
    }), /*#__PURE__*/_jsx(Small, {
      use: "help",
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.presence.viewingLabel"
      })
    })]
  }) : null;
};
ThreadPresence.displayName = 'ThreadPresence';
ThreadPresence.propTypes = {
  threadId: PropTypes.string.isRequired
};
export default ThreadPresence;